import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_SafetyPlan = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_SafetyPlan' className='file-pdf-document'>
            <div className='file-template'>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Client Name: </span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>CID:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Implementation:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientName' name='txtClientName' className='add-only w-230 custom-add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFullName' name='txtFullName' className='add-only w-230 custom-add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtDateImplementation' name='txtDateImplementation' className='add-only w-230 custom-add-only' /></td>

                    </tr>
                </table>
                <p className='w-750'><span className='eleHeader'>Parent & Emergency Contact:</span></p>
                <ol>
                    <li>
                        <input type='text' id='txtParent' name='txtParent' className='add-only w-700 custom-add-only' /></li>
                    <li>
                        <input type='text' id='txtParent1' name='txtParent1' className='add-only w-700 custom-add-only' /></li>
                    <li>
                        <input type='text' id='txtParent2' name='txtParent2' className='add-only w-700 custom-add-only' /></li>
                </ol>
                <p className='w-750'><span className='eleHeader'>Risky/ Unsafe/ Concerning Behaviors:</span></p>
                <ol>
                    <li>
                        <input type='text' id='txtRisky' name='txtRisky' className='add-only w-700 custom-add-only' /></li>
                    <li>
                        <input type='text' id='txtRisky1' name='txtRisky1' className='add-only w-700 custom-add-only' /></li>
                    <li>
                        <input type='text' id='txtRisky2' name='txtRisky2' className='add-only w-700 custom-add-only' /></li>
                </ol>
                <p className='w-750'><span className='eleHeader'>Date of Last Hospitalization/ Out of Home Placement/ Arrest:</span></p>
                <ol>
                    <li>
                        <input type='text' id='txtDate' name='txtDate' className='add-only' /></li>
                    <li>
                        <input type='text' id='txtDate1' name='txtDate1' className='add-only' /></li>
                </ol>
                <p className='w-750'><span className='eleHeader'>Steps for client, parents, and/or others to take:</span></p>
                <ol>
                    <li>
                        <input type='text' id='txtSteps' name='txtSteps' className='add-only w-700 custom-add-only' /></li>
                    <li>
                        <input type='text' id='txtSteps1' name='txtSteps1' className='add-only w-700 custom-add-only' /></li>
                    <li>
                        <input type='text' id='txtSteps2' name='txtSteps2' className='add-only w-700 custom-add-only' /></li>
                    <li>
                        <input type='text' id='txtSteps3' name='txtSteps3' className='add-only w-700 custom-add-only' /></li>
                    <li>
                        <input type='text' id='txtSteps4' name='txtSteps4' className='add-only w-700 custom-add-only' /></li>
                </ol>
                <p className='w-750'><span className='eleHeader'>Things to Avoid:</span></p>
                <ol>
                    <li>
                        <input type='text' id='txtThings' name='txtThings' className='add-only w-700 custom-add-only' /></li>
                    <li>
                        <input type='text' id='txtThings1' name='txtThings1' className='add-only w-700 custom-add-only' /></li>
                    <li>
                        <input type='text' id='txtThings2' name='txtThings2' className='add-only w-700 custom-add-only' /></li>
                </ol>
                <p className='w-750'>
                    <span className='eleHeader'>Special Supervision Plans and Responsible Parties:</span>
                    <textarea id='txtSupervision' name='txtSupervision' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Who Will be Responsible for Completion of Plan: </span>
                    <textarea id='txtResponsible' name='txtResponsible' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Key People to Help the Client: </span>
                    <textarea id='txtKey' name='txtKey' className='add-only'></textarea>
                </p>


            </div>
        </form>

    )
}











